import { FC } from 'react';
import type { MdTextBlock as MdTextBlockType } from '@/types/blocks';
import Markdown from '@/components/Markdown/Markdown';

export const MdTextBlock: FC<{ block: MdTextBlockType }> = ({ block }) => (
  <Markdown>{block.content}</Markdown>
);
